@if (isFontAwesomeIcon()) {
<i [attr.class]="'app-icon app-icon--font-awesome ' + icon()" [style.color]="color()" [style.width.px]="width()"
	[style.height.px]="height()" aria-hidden="true"></i>
} @else if (usesMask()) {
<span class="app-icon app-icon--mask" [style.background-color]="color()" [style.width.px]="width()"
	[style.height.px]="height()" [style.mask-image]="'url(' + iconSource() + ')'"
	[style.-webkit-mask-image]="'url(' + iconSource() + ')'" aria-hidden="true"></span>
} @else {
<img class="app-icon app-icon--image" [ngSrc]="iconSource()" [width]="width()" [height]="height()" [alt]="alt()"
	[attr.aria-hidden]="alt() ? null : 'true'" />
}
